<template>
	<div v-if="room">
	<LeftSidebar :dark=true :width="550" :updateSidebar="updateContentSidebar"
		:open="this.$vuetify.breakpoint.xsOnly ? contentSidebarOpen && phoneSidebarOpen : contentSidebarOpen"
		:class="{ 'grey lighten-2' : !darkTheme, 'grey darken-2' : darkTheme }" 
		:lowerTitle="true"
		:actionIcon="!room.restrictPhoto && userProfile.employeeID != '' ? 'add_a_photo' : null"
		:actionFunction="!room.restrictPhoto && userProfile.employeeID != '' ? addPhoto : noFunction"
		:actionTooltip="!room.restrictPhoto && userProfile.employeeID != '' ? 'Add Photo' : null"
		:actionIcon4="isManagerOfRoom(room) || isSuperUser ? 'line_style' : null"
		:actionFunction4="gotoRoomViewer"
		actionTooltip4="Launch RoomViewer"
		:actionIcon3="'grading'"
		:actionFunction3="showAmenities"
		actionTooltip3="Room Amenities"
		:actionIcon2="(isSuperUser || hasRole('Photo - Restrict')) ? 'no_photography' : null"
		:actionFunction2="function () { restrictPhotoDialog = true }"
		actionTooltip2="Photo Restrict"
		style="z-index: 31 !important"	>
		
		<div slot="sbTitle">
			Room {{ number }}
    	</div> 

    	<div slot="sbContent" class="caption">
    		<PhotoUpload />
    		<v-card v-if="roomPhotos"  height="300" class="mx-4">
	    		<v-pannellum autoRotate v-if="room360PhotoURL" :src="room360PhotoURL" :hfov="100" showZoom showFullscreen>
	    		</v-pannellum> 
	    		<v-carousel v-if="!room360PhotoURL" height="300" hide-delimiters cycle interval="4000"
	    			:hide-controls="this.fullRoom && this.fullRoom.roomImages.length > 1 ? false : true">
				    <v-carousel-item
				      v-for="(photo,i) in roomPhotos"
				      @click="setShowPhotoViewer(true)"
				      :key="i"
				      :src="photo.url">
				      	<div class="headline px-2" v-if="!photo.reviewed" 
				      	style="position: absolute; top: 0px; background-color: white; color: black; " 
				      		>
							Pending
						</div>
						<div class="headline" v-if="photo.tags" width="100%"
				      	style="opacity: 0.6; background-color: white; color: black; text-align: center;" 
				      		>
							{{niceTags(photo.tags)}}
						</div>
						
				    	<!-- <span class="headline" v-if="!photo.reviewed" style="position: absolute; left: 10px; top: 3px;" >
							Pending
						</span> -->
					</v-carousel-item>
					
				 </v-carousel>  
				 <v-btn dark class="ml-4 buttonhigher" @click="setShowPhotoViewer(true)" 
          			v-if="this.fullRoom && this.fullRoom.roomImages.length > 1 || isSuperUser">
	        		Gallery
	        		</v-btn>
          	</v-card>

   	
   		
    		<v-card class="mx-4 pl-2 py-2 mb-3 mt-2" v-if="$vuetify.breakpoint.xsOnly">

	    		<v-container>
	    		<v-layout row 
		    		v-for="(item, index) in items"
		    		:key="index" 
		    		class="mb-1"	    		
		    		style="align-items: flex-start;"
		    		align-start>
		        		<v-flex xs4>{{ item.label }}</v-flex>
		        		<v-flex xs8 class="mx-0">{{ item.val }}</v-flex>
		        </v-layout>
		        </v-container>
		    </v-card>
			

			<v-list class="pl-2 mt-2" v-if="!$vuetify.breakpoint.xsOnly">

	    		<!-- READONLY LAYOUT -->
	    		<v-layout v-if="!isManagerOfRoom(room)" column>
	    		<v-list-tile v-if="item.val && item.val" :key="index" 
		    		v-for="(item, index) in items"		    		
		    		class="datatile">
					<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">{{ item.label }}</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-flex xs7 sm9 class="mx-2" style="font-weight: 400;">
	        			<v-card>
	        				<v-card-text class="py-1">{{ item.val }}</v-card-text>
	        			</v-card>
	        		</v-flex>
		        </v-list-tile>
		    	</v-layout>

		    	<!-- EDITABLE LAYOUT -->
		    	<v-layout v-else column>

		    	<v-list-tile>
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Floor</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field v-model="room && room.floor" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				readonly
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Area</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field :value="room && `${room.area} sf`" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				readonly
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">College</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field :value="room && `${room.collegeName} (${room.collegeID})`" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				readonly
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Department</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field :value="room && `${room.deptName} (${room.deptID})`" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				readonly
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Category</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field :value="room && `${room.categoryName} (${room.category})`" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				readonly
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Type</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-autocomplete
							:items="types"
							@input="changed=true"
							@change="changed = true"
							item-text="nameAndID"
							item-value="typeID"
							v-model="room && room.type"
							cache-items
							class="mx-2 sliminput"
							solo
							hide-no-data
							hide-details
							label="Class">
					</v-autocomplete>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Use</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-autocomplete
							:items="uses"
							@input="changed=true"
							@change="changed = true"
							item-text="nameAndID"
							item-value="useID"
							v-model="room && room.use"
							cache-items
							class="mx-2 sliminput"
							solo
							hide-no-data
							hide-details
							label="Use">
					</v-autocomplete>
	        	</v-list-tile>



	        	

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Capacity</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field v-model="room && room.capacity" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				label="Capacity"
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile>

	        	<!-- <v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">w/Distancing</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-text-field v-model="room && room.tempCapacity" 
	        				class="mx-2 sliminput"
	        				@change="changed = true"
	        				label="Not Set"
	        				solo
	        				hide-details>
	        		</v-text-field>
	        	</v-list-tile> -->

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Class</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-autocomplete
							:items="classifications"
							@input="changed=true"
							@change="changed = true"
							item-text="classificationName"
							item-value="classificationName"
							v-model="room && room.classification"
							cache-items
							class="mx-2 sliminput"
							solo
							hide-no-data
							hide-details
							label="Class">
					</v-autocomplete>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Condition</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-autocomplete
							:items="['Fair', 'Good', 'Poor']"
							@input="changed=true"
							@change="changed = true"
							v-model="room && room.condition"
							cache-items
							class="mx-2 sliminput"
							solo
							hide-no-data
							hide-details
							label="Not Set">
					</v-autocomplete>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Suitability</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-autocomplete
							:items="['Aligned', 'Not aligned', 'Misaligned']"
							@input="changed=true"
							@change="changed = true"
							v-model="room && room.suitability"
							cache-items
							class="mx-2 sliminput"
							solo
							hide-no-data
							hide-details
							label="Not Set">
					</v-autocomplete>
	        	</v-list-tile>

	        	<v-list-tile class="slimtile">
		        	<v-flex xs5 sm3>
	        			<v-card>
	        				<v-card-text class="py-1 text-xs-right">Utilization</v-card-text>
	        			</v-card>
	        		</v-flex>

	        		<v-autocomplete
							:items="['High', 'Low', 'Vacant']"
							@input="changed=true"
							@change="changed = true"
							v-model="room && room.utilization"
							cache-items
							class="mx-2 sliminput"
							solo
							hide-no-data
							hide-details
							label="Not Set">
					</v-autocomplete>
	        	</v-list-tile>

	        	<v-layout v-if="changed" class="mr-4 pr-3">
		        	<v-flex xs6 class="mr-4">
		        		<v-btn block @click="saveClick(room)" class="ml-3 mr-4" color="blue lighten-1">Save</v-btn>
		        	</v-flex>
		        	<v-flex xs6>
		        		<v-btn block @click="{{refreshRoom(); changed=false;}}" class="ml-3 mr-4" color="blue lighten-1">Cancel</v-btn>
		        	</v-flex>
		        </v-layout>
		    </v-layout>


		    </v-list>

		    <v-flex xs12 class="mr-5">
		  		<v-toolbar class="ml-4">
		  			
					    <v-toolbar-title class="subheading">		    	
							{{fullRoom && fullRoom.PCT.length > 1 ? 'Assigned Departments' : 'Assigned Department'}}
						</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-toolbar-items class="mt-3">
							<v-tooltip left>
							<EditDepartmentsDialog 
								v-if="isSuperUser || isManagerOfRoom(fullRoom)" slot="activator"
                            	:room="fullRoom"
                            	v-on:refresh="refreshRoom"
							/>
							<span>Edit Assignments</span>
						</v-tooltip>
						</v-toolbar-items>
					
    				
				</v-toolbar>
				<v-progress-linear class="ml-4 mt-0" v-if="!fullRoom" color="blue" indeterminate></v-progress-linear>
			</v-flex>

			<v-flex class="mx-2">

	        <v-expansion-panel class="mt-2 px-3" v-if="fullRoom" popout expand v-model="activePanel">
		        <v-expansion-panel-content class="pt-3"  v-for="(dept,i) in fullRoom.PCT" :key="i" >
		        	<v-layout align-center justify-space-between style="font-weight: 500;" slot="header" >
                    <v-layout column class="subheading" style="font-weight: 500;" slot="header">
			            <v-flex>
			            	{{ dept.deptName }}
			            	<span class="body-1"> - {{ dept.deptID }} </span> 
			            	<v-tooltip top>
			            		<AddUserDepartment v-if="isManagerOfDept(dept)" 
			            				style="position: relative; top:-1px; left:-10px;"
						            	slot="activator" 
						            	:room="fullRoom"
						            	:deptPCT="dept"						            	 
						            	v-on:success="refreshRoom"/>
			            		<span>Add/Change User Dept</span>
			            	</v-tooltip>

			            </v-flex>
			            
			            <div v-if="dept.userDeptName">
			            	<img src="../images/subtree.png">
			            	{{ dept.userDeptName }}	<span class="body-1"> - {{ dept.userDeptID }} </span> 
			            </div>
			            <div class="body-1" style="position:relative; top:-5px;">{{ dept.percentage }}%</div>
		        	</v-layout>
		        	
                	</v-layout>

		            <v-card>

		            	<v-list class="pl-2" v-if="dept.occupant.length > 0 || isManagerOfDept(dept) || isOccupantEditorOfDept(dept) " two-line>
				          <template >
				          	<v-divider></v-divider>
				          	<v-layout row justify-space-between class="">
					            <v-subheader>Occupants</v-subheader>
					            <v-tooltip left>
						            <AddOccupant v-if="isManagerOfDept(dept) || isOccupantEditorOfDept(dept)"
						            	class="mr-2" slot="activator" 
						            	:deptPCT="dept"
						            	:room="room"
						            	v-on:updateLoading="(value) => { loading=value }" 
						            	v-on:success="refreshRoom"/>
						            <span>Add Occupant</span>
								</v-tooltip>
							</v-layout>
				            
				            <v-list-tile class="xTile" v-for="(occupant,i) in dept.occupant"  :key="dept.occupant.key"  >
				              	<v-list-tile-content>
				                	<v-list-tile-title v-html="occupant.name"></v-list-tile-title>
				                	<v-list-tile-sub-title v-html="occupant.title"></v-list-tile-sub-title>				                	
				              	</v-list-tile-content>

				              	<v-tooltip right v-if="isManagerOfDept(dept) || isOccupantEditorOfDept(dept)" >
				              		<v-dialog slot="activator" v-model="removeOccupantDialog[i+dept.deptID]" persistent max-width="390">
					                <v-btn  slot="activator" icon>
					                	<v-icon small color="red lighten-2">close</v-icon>
					                </v-btn>
						                <v-card class="pl-2 pt-1 pr-2">
									        <v-card-title class="headline">Delete Occupant</v-card-title>
									        <v-divider></v-divider>
									        <v-card-text class="pt-4 body-2">{{occupant.name}} in {{room && room.number}}?</v-card-text>
									        <v-card-actions>
									          	<v-spacer></v-spacer>
									          	<v-btn color="green darken-1" flat @click.native="removeOccupantDialog[i+dept.deptID] = false">No</v-btn>
									      	 	<v-btn color="green darken-1" flat 
									          		@click.native="delOccupant(occupant, i+dept.deptID)">Yes
									      	 	</v-btn>
									        </v-card-actions>
								      	</v-card>
							    	</v-dialog>
					                <span>Delete Occupant</span>
					            </v-tooltip>

				            </v-list-tile>
				          </template>
				        </v-list>

		            	<v-list class="pl-2" v-if="dept.PI.length > 0 || isManagerOfDept(dept) || isOccupantEditorOfDept(dept) " two-line>
				          <template >
				          	<v-divider></v-divider>
				          	<v-layout row justify-space-between class="">
					            <v-subheader>Principal Investigators</v-subheader>
					            <v-tooltip left>
						            <AddPI v-if="isManagerOfDept(dept) || isOccupantEditorOfDept(dept)"
						            	class="mr-2" slot="activator" 
						            	:deptPCT="dept"
						            	v-on:updateLoading="(value) => { loading=value }"
						            	v-on:success="refreshRoom" />
						            <span>Add Principal Investigator</span>
								</v-tooltip>
							</v-layout>
				            
				            <v-list-tile class="xTile" v-for="(pi,i) in dept.PI" :key="dept.PI.key"  >
				              	<v-list-tile-content>
				                	<v-list-tile-title v-html="pi.name"></v-list-tile-title>
				                	<v-list-tile-sub-title v-html="pi.title"></v-list-tile-sub-title>
				              	</v-list-tile-content>

				              	<v-tooltip left v-if="isManagerOfDept(dept) || isOccupantEditorOfDept(dept)" >
				              		<v-dialog slot="activator" v-model="delPIDialog[i+dept.deptID]" persistent max-width="290">
					                <v-btn  slot="activator" icon>
					                	<v-icon small color="red lighten-2">close</v-icon>
					                </v-btn>
						                <v-card class="pl-2 pt-1 pr-2">
									        <v-card-title class="headline">Delete PI</v-card-title>
									        <v-divider></v-divider>
									        <v-card-text class="pt-4 body-2">{{pi.name}} in {{room && room.number}}?</v-card-text>
									        <v-card-actions>
									          	<v-spacer></v-spacer>
									          	<v-btn color="green darken-1" flat @click.native="delPIDialog[i+dept.deptID] = false">No</v-btn>
									          	<v-btn color="green darken-1" flat 
									          		@click.native="delPI(pi, i+dept.deptID)">Yes
									      	 	 </v-btn>
									        </v-card-actions>
								      	</v-card>
							    	</v-dialog>
					                <span>Delete</span>
					            </v-tooltip>

				            </v-list-tile>
				          </template>
				        </v-list>


		            </v-card>
		        </v-expansion-panel-content>
	        </v-expansion-panel>

	    	<OccupantHistoryDialog :selectedRoom="room" v-if="allowManagerUI || allowOccupantEditorUI" class="ml-2" />

		</v-flex>

    	</div>	    

    	


	</LeftSidebar>
	<v-dialog v-model="restrictPhotoDialog" persistent max-width="390">					                                
            <v-card class="pl-2 pt-1 pr-2">
                <v-card-title class="headline">RESTRICT PHOTOS</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4 body-2">
                	<!-- {{room}} -->
                <v-switch
			      v-model="room.restrictPhoto"
			      label="Restrict Photos"
			      @change="photoRestrict(room.restrictPhoto, room)"
			    ></v-switch></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat @click.native="restrictPhotoDialog = false">Done</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
	</div>
</template>

<script>

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import LeftSidebar from './LeftSidebar'
import OccupantHistoryDialog from './OccupantHistoryDialog'
import ApplyProgramsDialog from './forms/ApplyProgramsDialog'
import EditDepartmentsDialog from './forms/EditDepartmentsDialog'
import AddOccupant from './forms/AddOccupant'
import AddUserDepartment from './forms/AddUserDepartment'
import AddPI from './forms/AddPI'
import PhotoUpload from './forms/PhotoUpload'
import Vue from 'vue'
import VuePannellum from 'vue-pannellum'
Vue.component('VPannellum', VuePannellum)
import { NETID_COOKIE } from '@/store/modules/user'
import jscookie from 'js-cookie'


  	let ContentSidebar = {

		data() {
	  		return {
	  			activePanel : [1],
	  			removeOccupantDialog: {},
	  			delPIDialog: {},
	  			delRmpct: {},
	  			loading: false,
	  			changePercentage: null,
	  			hide360: false,
	  			changed: false,
	  			restrictPhotoDialog: false,
	  		}
		},

		components : { VuePannellum, LeftSidebar, AddOccupant, AddUserDepartment, AddPI, PhotoUpload, ApplyProgramsDialog, EditDepartmentsDialog, OccupantHistoryDialog },

		watch: { //Reset Expansion Panels on room change
		    '$store.state.space.selectedRoom': function (newval) {
		    	this.changed = false
		    	this.activePanel = [1]
		    },
		    
		    loading (newVal) {
				console.log("Loading")
			}
	  	},

		computed: {

			...mapState({
				phoneSidebarOpen: state => state.ui.phoneSidebarOpen,
				contentSidebarOpen: state => state.ui.contentSidebarOpen,
				mainSidebarOpen: state => state.ui.mainSidebarOpen,
				room: state => state.space.selectedRoom,
				bldg: state => (state.space.selectedRoom) ? state.space.selectedRoom.bldgAlpha : null,
				number: state => (state.space.selectedRoom) ? state.space.selectedRoom.number : null,
				fullRoom: state => state.space.fullRoom,
				highlightRoom () { return this.$store.state.space.highlightRoom },
				darkTheme: state => state.ui.darkTheme,
				userManagedDepts: state => state.user.userManagedDepts,
				isSuperUser: state => state.user.isSuperUser,
				classifications: state => state.lists.classifications,
				types: state => state.lists.types,
				uses: state => state.lists.uses,
				useDevDatabase: state => state.ui.useDevDatabase,
				colorDomain: state => state.colorRooms.colorDomain,
				userProfile: state => state.user.userProfile,
			}),

			...mapGetters(['isManagerOfRoom', 'isManagerOfDept', 'isOccupantEditorOfDept', 'allowManagerUI', 'allowOccupantEditorUI', 'hasRole']),

			roomPhotos : function () {
				let returnVal = []
				this.fullRoom && this.fullRoom.roomImages.length > 0 && 
				this.fullRoom.roomImages.forEach((photo) => {
					if (photo.reviewed || this.isOwner(photo)) { returnVal.push(photo) }
				})
				return returnVal.length > 0 ? returnVal : null
			},
			
			room360PhotoURL : function(){
				let returnVal = null
				if (this.fullRoom && this.fullRoom.roomImages.length > 0 ) {
					this.fullRoom.roomImages.forEach((photo) => {
						if (photo.url.includes("360Pano") && photo.reviewed) {
							console.log(photo.url)
							returnVal =  photo.url
						}
					})
					return returnVal
				}
			},

			items: function () {
			  	if (this.$store.state.space.selectedRoom) {
			  	return 	[
				  		{ label: 'Floor', val: this.$store.state.space.selectedRoom.floor },
				  		{ label: 'Area', val: this.$store.state.space.selectedRoom.area + " sf"},
				  		{ label: 'College', val: this.$store.state.space.selectedRoom.collegeName + " (" + this.$store.state.space.selectedRoom.collegeID + ")" },
				  		{ label: 'Dept', val: this.$store.state.space.selectedRoom.deptName + " (" + this.$store.state.space.selectedRoom.deptID + ")" },
				  		{ label: 'Category', val: this.$store.state.space.selectedRoom.categoryName + " (" + this.$store.state.space.selectedRoom.category + ")" },
				  		{ label: 'Type', val: this.$store.state.space.selectedRoom.typeName + " (" + this.$store.state.space.selectedRoom.type + ")" },
				  		{ label: 'Use', val: this.$store.state.space.selectedRoom.useName + " (" + this.$store.state.space.selectedRoom.use + ")" },
				  		{ label: 'Capacity', val: this.$store.state.space.selectedRoom.capacity },
				  		{ label: 'w/Distancing', val: this.$store.state.space.selectedRoom.tempCapacity },
				  		{ label: 'Class', val: this.$store.state.space.selectedRoom.classification},
				  		{ label: 'Condition', val: this.$store.state.space.selectedRoom.condition},
				  		{ label: 'Suitability', val: this.$store.state.space.selectedRoom.suitability},
				  		{ label: 'Utilization', val: this.$store.state.space.selectedRoom.utilization},
			  			]
			  	}
			}
		},

		methods: {
		  	...mapMutations(['updateContentSidebar', 'setShowPhotoViewer', 'setShowPhotoUpload', 'setSnackText', 'updateRoomAmenitySidebarOpen']),

		  	...mapActions(['updateOccupant', 'deletePI', 'deleteRoomPercentage', 'fetchFullRoom', 'saveRoom', 'deleteOccupant', 'fetchBuildingRooms', 'buildColorizedLegendArray', 'updatePhotoRestrict'  ]),

/*	  		// True if logged in user's any of this user's managed depts are assigned to this room.
	  		isManagerOfRoom: function () {
	  			if (!this.room || !this.room.PCT) { return }
	  			let roomDepts = []
	  			let retCode = false
	  			this.room.PCT.forEach((dept) => roomDepts.push(dept.deptID) )
	  			this.userManagedDepts.forEach((userDept) => {
	  				roomDepts.forEach((dept) => {
	  					if (userDept == dept) {
	  						//console.log("Match", dept)
	  						retCode = true
	  					}
	  				})
	  			})
	  			return retCode
			},*/

			gotoRoomViewer() {
				console.log("Launch RoomViewer")
				this.$router.push({ name: 'RoomViewerToBldgRoom', params: { rvbldg: this.bldg, rvroom: this.room.number }})
				//this.$router.push('/bldgviewer/`${this.bldg}`/`${this.room.number}`')
				this.updateContentSidebar(false)
			},

			niceTags(stringArray) {
				return stringArray && stringArray.join(", ")
			},

			isOwner: function (photo) {
				let netId = jscookie.get(NETID_COOKIE)
				if (this.isSuperUser || photo.netID == netId) { return true}
			},

			saveClick: function (room) {
				this.saveRoom(room)
				this.changed=false
				this.setSnackText('Saved')
				this.refreshRoom()				
			},

			markOccupantInactive: function (occupant, i) {
				this.removeOccupantDialog[i] = false
				occupant.current = false
				this.updateOccupant({ key: occupant.key, current: false })
			},

			delOccupant: function (occupant, i) {
				this.removeOccupantDialog[i] = false
				this.deleteOccupant({ 'key': occupant.key }).then(this.refreshRoom())		
			},

			delPI: function (pi, i) {				
				this.delPIDialog[i] = false
				this.deletePI({ key: pi.key }).then(this.refreshRoom())
				//pis.splice(i, 1) // Remove from local memory
			},

			delRoomPercentage: function (key, i) {
				this.delRmpct[i] = false
				this.deleteRoomPercentage({ key: key })
				this.refreshRoom()
			},

			addPhoto: function () {
				this.setShowPhotoUpload(true)
			},
			
			noFunction() {
				//Nothing
			},

			showAmenities: function () {
				this.updateRoomAmenitySidebarOpen(true)
			},

			refreshRoom: function () {
				this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number})
				// If coloring is active, recolor rooms after change. 
				this.colorDomain && this.fetchBuildingRooms(this.room.bldgAlpha).then(this.buildColorizedLegendArray)
			},

			photoRestrict (restrictPhoto, room) {
				this.updatePhotoRestrict({ restrictPhoto: restrictPhoto, rooms: [room] })
			},
		}						
	}
export default ContentSidebar
</script>


<style>

.slimtile .v-list__tile {
    align-items:  flex-start;
    height: 42px;
}

.xTile > .v-list__tile {
	height: 60px;
	padding-right: 8px;
}

.sliminput .v-input__slot {
	min-height: auto !important;
}

.sliminput .v-input__control {
	min-height: auto !important;
}

.gotoGallery {
	position: relative;
	bottom: 120px;
	left: 450px;
}

.buttonhigher {
	position: relative;
	bottom: 48px;
	left: -19px;
	opacity: 0.6;
}

</style>





// WEBPACK FOOTER //
// src/components/ContentSidebar.vue